import { TimelineStore } from '../timeline.store';
import { RecorderStore } from '../../stores/recorder.store';
import { TIMELINE_TICK_WIDTH } from '../../../constants';
import { nearestDividend } from '../../../shared/helpers/math.helpers';
import { Player } from '../../entities/player';
import { Recorder } from '../../entities/recorder';
var TimelineButtonsComponent = /** @class */ (function () {
    function TimelineButtonsComponent(timelineStore, recorderStore, recorder, player) {
        this.timelineStore = timelineStore;
        this.recorderStore = recorderStore;
        this.recorder = recorder;
        this.player = player;
        this.inButtonIsDisabled = false;
        this.outButtonIsDisabled = false;
    }
    TimelineButtonsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.zoomChangeSubscriber = this.timelineStore.zoomChange
            .subscribe(function () { return _this.onZoomChange(); });
    };
    TimelineButtonsComponent.prototype.ngOnDestroy = function () {
        this.zoomChangeSubscriber.unsubscribe();
    };
    TimelineButtonsComponent.prototype.onZoomChange = function () {
        this.updateButtonStates();
    };
    TimelineButtonsComponent.prototype.updateButtonStates = function () {
        this.outButtonIsDisabled = this.timelineStore.isMinZoom();
        this.inButtonIsDisabled = this.timelineStore.isMaxZoom();
    };
    TimelineButtonsComponent.prototype.onZoomOutButtonClick = function () {
        this.timelineStore.zoom /= 2;
    };
    TimelineButtonsComponent.prototype.onZoomInButtonClick = function () {
        this.timelineStore.zoom *= 2;
    };
    Object.defineProperty(TimelineButtonsComponent.prototype, "startButtonIsDisabled", {
        get: function () {
            return this.recorder.recording || this.player.playback || this.timelineStore.currentPosition === 0;
        },
        enumerable: true,
        configurable: true
    });
    TimelineButtonsComponent.prototype.onStartButtonClick = function () {
        this.timelineStore.currentPosition = 0;
    };
    Object.defineProperty(TimelineButtonsComponent.prototype, "endButtonIsDisabled", {
        get: function () {
            return this.recorder.recording ||
                this.player.playback ||
                this.recorderStore.recordData.length === 0 ||
                this.timelineStore.currentPosition === this.recorderStore.recordData.length;
        },
        enumerable: true,
        configurable: true
    });
    TimelineButtonsComponent.prototype.onEndButtonClick = function () {
        this.timelineStore.currentPosition = this.recorderStore.recordData.length;
    };
    Object.defineProperty(TimelineButtonsComponent.prototype, "backwardButtonIsDisabled", {
        get: function () {
            return this.timelineStore.currentPosition === 0;
        },
        enumerable: true,
        configurable: true
    });
    TimelineButtonsComponent.prototype.onBackwardButtonClick = function () {
        var step = this.timelineStore.convertPixelsToMilliseconds(TIMELINE_TICK_WIDTH);
        var currentPosition = this.timelineStore.currentPosition;
        var roundedCurrentPosition = nearestDividend(this.timelineStore.currentPosition, step);
        if (currentPosition > roundedCurrentPosition) {
            this.timelineStore.currentPosition = roundedCurrentPosition;
        }
        else {
            this.timelineStore.currentPosition = roundedCurrentPosition - step;
        }
    };
    TimelineButtonsComponent.prototype.onForwardButtonClick = function () {
        var step = this.timelineStore.convertPixelsToMilliseconds(TIMELINE_TICK_WIDTH);
        var currentPosition = this.timelineStore.currentPosition;
        var roundedCurrentPosition = nearestDividend(this.timelineStore.currentPosition, step);
        if (currentPosition < roundedCurrentPosition) {
            this.timelineStore.currentPosition = roundedCurrentPosition;
        }
        else {
            this.timelineStore.currentPosition = roundedCurrentPosition + step;
        }
    };
    return TimelineButtonsComponent;
}());
export { TimelineButtonsComponent };



// WEBPACK FOOTER //
// ./src/app/rec/timeline/timeline-buttons/timeline-buttons.component.ts.pre-build-optimizer.js